import { Link, Outlet, useParams } from "react-router-dom";
import { accountText } from "../pages/account/_accountText";

export default function CustomerLayout() {
  const { lang = "en" } = useParams();
  const x = accountText(lang);
  const links = ["profile", "addresses", "orders", "messages", "tickets", "wishlist", "returns"];
  const labels: Record<string, string> = { profile: x.profile, addresses: lang === "zh" ? "收货地址" : "Addresses", orders: x.orders, messages: x.messages, tickets: x.tickets, wishlist: x.wishlist, returns: x.returns };
  return (
    <div className="container-page grid gap-6 py-8 md:grid-cols-[220px_1fr]">
      <aside className="panel p-4">
        <h2 className="mb-3 font-bold">{x.overview}</h2>
        {links.map((link) => <Link key={link} className="admin-link capitalize" to={`/${lang}/account/${link}`}>{labels[link]}</Link>)}
      </aside>
      <section className="panel p-5"><Outlet /></section>
    </div>
  );
}
